let Application = /*#__PURE__*/function (Application) {
  Application["API"] = "api";
  Application["BULK"] = "bulk";
  Application["CHECKOUT"] = "consumer-flow";
  Application["SINGLE_FLOW"] = "single-flow";
  Application["PACKOFFICE"] = "packoffice";
  Application["AUTH"] = "auth";
  Application["INTERNAL_TOOL"] = "internal-tool";
  return Application;
}({});

export { Application };
//# sourceMappingURL=Application.js.map
